import { useQuery } from "@tanstack/react-query";
import { contractorDetailsApi } from "../api/contractorApi";

export const useFetchActivityList = (contractorId: string | null) => {

    const { data, isFetching, isSuccess, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractor-activity-list", contractorId],
        queryFn: () => contractorDetailsApi.fetchActivityList(contractorId),
        enabled: !!contractorId,
    });

    return {
        data: isSuccess ? data.rows : [],
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};